<template>
    <div>
        <div class="banner">
            <img v-bind:src="banner" />
            <div class="banner_main">
                <h2>弘扬科学家精神</h2>
                <h3>Carry forward the spirit of scientists</h3>
                <h4>尊重知识、崇尚创新、尊重人才、热爱科学、献身科学</h4>
                <form method="post" onsubmit="return false;" class="flex_start align_items_center">
                    <input type="text" name="search_key" v-model="search_key" />
                    <button @click="searchBtn()">搜索</button>
                </form>
                <ul class="flex_space_between">
                    <li><router-link to="/audit/index">音频</router-link></li>
                    <li><router-link to="/video/index">视频</router-link></li>
                    <li><router-link to="/teximg/index">图文</router-link></li>
                    <li><router-link to="/book/index">电子书</router-link></li>
                    <li><router-link to="/wall/index">挂图</router-link></li>
                    <li><router-link to="/pic/index">图片</router-link></li>
                </ul>
            </div>
        </div>

        <div class="text_pic">
            <div class="text_pic_top">
            </div>
            <div class="main">
                <div class="text_pic_top_title flex_space_between align_items_center">
                    <p>图文故事</p>
                    <router-link to="/teximg/index" class="flex_start align_items_center">更多<img src="@/assets/images/icon_right.png" /></router-link>
                </div>
                <ul class="flex_space_between flex_wrap">

                    <li  v-for="(item,index) in datalist.teximg" class="flex_start" @click="goUrl(this,item.id,item.type)" v-if="index <= 2">
                        <div class="pic_box">
                            <img :src="item.pic" />
                        </div>
                        <div class="text_box">
                            <h2>{{item.title}}</h2>
                            <p>{{item.intro}}</p>
                            <!--<span class="flex_space_between">
                                <label>{{item.source}}</label>
                                <label>{{item.create_time}}</label>
                                <img src="@/assets/images/like.png" v-if="item.is_like == 0" />
                                <img src="@/assets/images/header_red.png" v-else />
                            </span>-->
                        </div>
                    </li>
                </ul>
            </div>
        </div>

        <div class="video web_hide">
            <div class="video_bg"><img src="@/assets/images/video_bg.jpg" /></div>
            <div class="main">
                <div class="text_pic_top_title no_before flex_space_between align_items_center">
                    <p>视频</p>
                    <router-link to="/video/index" class="flex_start align_items_center">更多<img src="@/assets/images/icon_right_white.png" /></router-link>
                </div>
                <div class="video_box flex_start">
                    <div class="video_list" v-for="(item,index) in datalist.video" @click="goUrl(this,item.id,item.type)">
                        <div class="video_list_img">
                            <img :src="item.pic" />
                        </div>
                        <h2 class="text_fff">{{item.title}}</h2>
                        <p class="flex_start align_items_center flex_wrap">
                            <span v-for="(val,key) in item.flag">{{val}}</span>
                        </p>
                    </div>
                </div>
            </div>
        </div>

        <div class="web_show">
            <div class="web_audit_swiper">
                <div class="web_audit_swiper_bg">
                    <img src="@/assets/images/video_bg.jpg" />
                </div>
                <div class="main">
                    <div class="text_pic_top_title no_before pa_top_15 padding_left_half flex_space_between align_items_center">
                        <p>视频</p>
                        <router-link to="/video/index" class="flex_start align_items_center">更多<img src="@/assets/images/icon_right_white.png" /></router-link>
                    </div>
                    <div class="audit_box flex_start flex_wrap">
                        <div class="swiper-container video_container">
                            <div class="swiper-wrapper">
                                <div class="swiper-slide audit_list" v-for="(item,index) in datalist.video" @click="goUrl(this,item.id,item.type)">
                                    <div class="audit_list_img">
                                        <img :src="item.pic" />
                                    </div>
                                    <h2>{{item.title}}</h2>
                                    <p class="flex_start flex_wrap">
                                        <span v-for="(val,key) in item.flag">{{val}}</span>
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div class="swiper-button-prev video_prev web_audit_page_btn">
                            <img src="@/assets/images/left.png" />
                        </div>
                        <div class="swiper-button-next video_next web_audit_page_btn">
                            <img src="@/assets/images/right.png" />
                        </div>
                    </div>
                </div>


            </div>
        </div>


        <div class="audit">

            <div class="web_hide">
                <div class="main">
                    <div class="text_pic_top_title no_before pa_top_15 padding_left_half flex_space_between align_items_center">
                        <p>音频</p>
                        <router-link to="/audit/index" class="flex_start align_items_center">更多<img src="@/assets/images/icon_right.png" /></router-link>
                    </div>
                    <div class="audit_box flex_start flex_wrap">
                        <div class="audit_list" v-for="(item,index) in datalist.audit" @click="goUrl(this,item.id,item.type)">
                            <div class="audit_list_img">
                                <img :src="item.pic" />
                            </div>
                            <h2>{{item.title}}</h2>
                            <p class="flex_start flex_wrap">
                                <span v-for="(val,key) in item.flag">{{val}}</span>
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="web_main">

                <div class="main mr_top_70">
                    <div class="text_pic_top_title mr_bottom_20 flex_space_between align_items_center">
                        <p>电子书</p>
                        <router-link to="/book/index" class="flex_start align_items_center">更多<img src="@/assets/images/icon_right.png" /></router-link>
                    </div>
                </div>
                <div class="main">
                    <div class="audit_box flex_start flex_wrap mr_bottom_20">
                        <div class="audit_list" v-for="(item,index) in datalist.book" @click="goUrl(this,item.id,item.type)">
                            <div class="audit_list_img">
                                <img :src="item.pic" />
                            </div>
                            <h2>{{item.title}}</h2>
                            <p class="flex_start flex_wrap">
                                <span v-for="(val,key) in item.flag">{{val}}</span>
                            </p>
                        </div>
                    </div>
                </div>
            </div>


            <div class="web_show">
                <div class="web_audit_swiper">
                    <div class="web_audit_swiper_bg">
                        <img src="@/assets/images/audit_bg.jpg" />
                    </div>
                    <div class="main">
                        <div class="text_pic_top_title no_before pa_top_15 padding_left_half flex_space_between align_items_center">
                            <p>音频</p>
                            <router-link to="/audit/index" class="flex_start align_items_center">更多<img src="@/assets/images/icon_right_white.png" /></router-link>
                        </div>
                        <div class="audit_box flex_start flex_wrap">
                            <div class="swiper-container audit_container">
                                <div class="swiper-wrapper">
                                    <div class="swiper-slide audit_list" v-for="(item,index) in datalist.audit" @click="goUrl(this,item.id,item.type)">
                                        <div class="audit_list_img">
                                            <img :src="item.pic" />
                                        </div>
                                        <h2>{{item.title}}</h2>
                                        <p class="flex_start flex_wrap audit_flag_list">
                                            <span v-for="(val,key) in item.flag">{{val}}</span>
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div class="swiper-button-prev audit_prev web_audit_page_btn">
                                <img src="@/assets/images/left.png" />
                            </div>
                            <div class="swiper-button-next audit_next web_audit_page_btn">
                                <img src="@/assets/images/right.png" />
                            </div>
                        </div>
                    </div>


                </div>
            </div>

            <div class="web_main">
                <div class="main mr_top_70">
                    <div class="text_pic_top_title mr_bottom_20 flex_space_between align_items_center">
                        <p>挂图</p>
                        <router-link to="/wall/index" class="flex_start align_items_center">更多<img src="@/assets/images/icon_right.png" /></router-link>
                    </div>
                </div>
                <div class="main">
                    <div class="wall_map flex_start overflow_x_auto">
                        <div class="wall_map_list wall_map_list_first" v-for="(item,index) in datalist.wall" @click="goUrl(this,item.id,item.type)" v-if="index == 0">
                            <div class="wall_map_img">
                                <img :src="item.pic" />
                            </div>
                            <h2>{{item.title}}</h2>
                            <p class="flex_start flex_wrap">
                                <span v-for="(val,key) in item.flag">{{val}}</span>
                            </p>
                        </div>
                        <div class="wall_map_list wall_map_list_second" v-for="(item,index) in datalist.wall" @click="goUrl(this,item.id,item.type)" v-if="index == 1">
                            <div class="wall_map_list_second_img">
                                <img :src="item.pic" />
                            </div>
                            <h2>{{item.title}}</h2>
                            <p class="flex_start flex_wrap">
                                <span v-for="(val,key) in item.flag">{{val}}</span>
                            </p>
                        </div>
                        <div class="wall_map_list wall_map_list_third" v-for="(item,index) in datalist.wall" @click="goUrl(this,item.id,item.type)" v-if="index == 2">
                            <div class="wall_map_list_third_img">
                                <img :src="item.pic" />
                            </div>
                            <h2>{{item.title}}</h2>
                            <p class="flex_start flex_wrap">
                                <span v-for="(val,key) in item.flag">{{val}}</span>
                            </p>
                        </div>
                    </div>
                </div>

            </div>
            <div class="web_main">
                <div class="main mr_top_70">
                    <div class="text_pic_top_title mr_bottom_20 flex_space_between align_items_center">
                        <p>图片</p>
                        <router-link to="/pic/index" class="flex_start align_items_center">更多<img src="@/assets/images/icon_right.png" /></router-link>
                    </div>
                </div>
                <div class="main no_bg flex_start overflow_x_auto">
                    <div class="img_list" v-for="(item,index) in datalist.pic" @click="goUrl(this,item.id,item.type)">
                        <div class="img_list_img">
                            <img :src="item.pic" />
                        </div>
                        <h2>{{item.title}}</h2>
                        <p class="flex_start flex_wrap">
                            <span v-for="(val,key) in item.flag">{{val}}</span>
                        </p>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import Swiper from "swiper";
    import "swiper/dist/css/swiper.min.css"
    export default {
        name: "index.vue",
        data () {
            return {
                banner: '',
                datalist:[],
                search_key: ''
            }
        },
        created() {
            this.$http({
                url: 'index/index',
                method: 'post',
                headers: {"Content-Type": "multipart/form-data"},
                data:{token:localStorage.getItem('user_token')}
            }).then(res => {
                if(res.data.code == 1) {
                    this.banner = res.data.data.banner;
                    this.datalist = res.data.data.article;
                    this.$nextTick(() => {
                        new Swiper(".audit_container", {
                            autoplay: 3000,
                            slidesPerView: 'auto',
                            nextButton: '.audit_next',
                            prevButton: '.audit_prev',
                        });
                        new Swiper(".video_container", {
                            autoplay: 3000,
                            slidesPerView: 'auto',
                            nextButton: '.video_next',
                            prevButton: '.video_prev',
                        });
                    });
                } else {
                    layer.msg(res.data.msg);
                }
            });
        },
        mounted() {

        },
        methods: {
            goUrl: function (obj,id,type) {
                this.$router.push({
                    path: '/' + type + '/detail',
                    query: {
                        id: id
                    }
                })
            },
            searchBtn: function () {
                let _this = this,
                    search_key = _this.search_key;
                if(search_key == '')
                {
                    layer.msg('请输入搜索关键词')
                    return false;
                }
                _this.$router.push({
                    path: '/home/search',
                    query: {
                        search_key: search_key
                    }
                })
            }
        },
        mounted(){
        }
    }
</script>
<style scoped>
    .swiper-container {
        width: 100%;
    }


    .web_show{display: none;}


    .banner{width:100%;display: block;position: relative;}
    .banner img{width:100%;object-fit: cover;max-height:100vh;min-height:500px;display: block;}
    .banner_main{width:760px;position: absolute;top:50%;left:50%;transform: translate(-50%,-50%);color:#fff;}
    .banner_main h2{width: 100%;font-size:72px;line-height: 72px;display: block;font-style: italic;}
    .banner_main h3{width: 100%;font-weight: normal;font-size:16px;line-height: 16px;letter-spacing: 7px;margin:10px 0 40px;}
    .banner_main h4{width: 100%;font-weight: normal;font-size:28px;line-height: 28px;letter-spacing: 3px;}
    .banner_main form{width:100%;height: 60px;line-height: 60px;margin:20px 0;}
    .banner_main form input{width: 645px;line-height: 60px;background: #fff;font-size:22px;padding:0 20px;border:none;}
    .banner_main form button{width: 115px;background: #1664ff;font-size: 26px;line-height: 60px;display: block;text-align: center;color:#fff;border:none;}
    .banner_main ul{
        width: 100%;height: 60px;line-height: 60px;
        background: -webkit-linear-gradient(left, #d86247,#e75e40 ,  #d86247); /* Safari 5.1 - 6.0 */
        background: -o-linear-gradient(right,  #d86247,#e75e40 ,  #d86247); /* Opera 11.1 - 12.0 */
        background: -moz-linear-gradient(right, #d86247,#e75e40 ,  #d86247); /* Firefox 3.6 - 15 */
        background: linear-gradient(to right,  #d86247,#e75e40 ,  #d86247); /* 标准的语法 */
    }
    .banner_main ul li{padding:0 30px;font-size: 18px;}
    .banner_main ul li a{color:#fff;}

    .text_pic{width:100%;background: #d9ecff;padding-top:70px;position: relative;}
    .text_pic .main ul{padding:0 4%;}
    .text_pic_top{width: 100%;background: #d9ecff;position: absolute;top:0;left:0;height: 225px;}
    .text_pic_top_title{width:100%;padding-left:40px;position: relative;background:#fff;height: 70px;line-height: 70px;margin-bottom: 40px;position: relative;z-index: 2;}
    .text_pic_top_title::before{content:"";position: absolute;top:0;left:0;width: 8px;height: 70px;background:#627eb6;}
    .no_before::before{display: none;}
    .text_pic_top_title p{width: auto;font-size:40px;color:#333;display: block;}
    .text_pic_top_title a{width: auto;font-size:20px;color:#333;display: block;padding-right: 10px;}
    .text_pic_top_title a img{height: 20px;object-fit: contain;display: block;width: 20px;margin-left:3px;}
    .text_pic ul {position: relative;z-index:2;}
    .text_pic ul li{width: 575px;height: 240px;padding:20px;background:#fff;border-radius: 3px;box-shadow: 0 0 20px rgba(170,176,194,.2);margin-bottom: 40px;}
    .text_pic ul li img,.pic_box{width: 200px;height: 200px;object-fit: cover;display: block;}
    .text_box{width:315px;display: block;margin-left:20px;}
    .text_box h2{width: 100%;font-size:22px;color:#333;line-height: 28px;font-weight: normal;height: 56px;overflow: hidden;}
    .text_box p{width: 100%;font-size:14px;line-height: 21px;color:#666;display: block;margin:10px 0 0;overflow: hidden;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
        overflow: hidden;
    }
    .text_box span label {margin-right: 40px;display: inline-block;color:#666;font-size:14px;line-height: 14px;}
    .text_box span img{width:auto !important;height: 14px !important;object-fit:contain;display:inline-block;}

    .video{width:100%;display: block;position: relative;padding-top:25px;}
    .video_bg{width:100%;height: 100%;position: absolute;top:0;right:0;bottom:0;left:0;z-index:1;}
    .video_bg img{width:100%;height: 100%;object-fit: cover;display: block;}
    .video .main{position: relative;z-index:2;}
    .video .text_pic_top_title{background: none;padding-left:19.5px;}
    .video .text_pic_top_title p,.video .text_pic_top_title a{color:#fff;}
    .video_box{width:100%;}
    .video_list{width:374px;display: block;min-width: 374px;margin-left:19.5px;}
    .video_list a{width: 100%;display: block;}
    .video_list_img{width:374px;height: 374px;border-radius: 10px;overflow: hidden;display: block;}
    .video_list_img img{width:100%;height: 100%;object-fit: cover;display: block;transition: all ease .5s;}
    .video_list:hover .video_list_img img{transform: scale(1.05);}
    .video_list h2{width:100%;padding-left:10px;color:#fff;font-size:30px;line-height: 50px;margin:25px 0 60px;display: block;font-weight: normal;}
    .video_list p{width:100%;padding-bottom: 65px;}
    .video_list p span{font-size:21px;line-height: 33px;border: 1px solid #fff;margin-right: 20px;padding:0 18px;border-radius: 10px;width: auto;display: block;margin-bottom: 5px;}
    .video_list p span:nth-child(3n),.video_list p span:first-child{color:#ff6000;border-color: #ff6000;}
    .video_list p span:nth-child(3n + 1){color:#00aeff;border-color: #00aeff;}
    .video_list p span:nth-child(3n + 2){color:#cf19da;border-color: #cf19da;}

    .audit{width:100%;background: #d9ecff;padding-top:75px;padding-bottom: 115px;}
    .audit .main{background: #fff;}
    .audit_box{width:100%;}
    .audit_list{width: 245px;margin:20px 40px 70px 20px;}
    .audit_list:nth-child(4n){margin-right: 20px;}
    .audit_list a{width: 100%;display: block;}
    .audit_list_img{width:100%;height: 245px;padding:8px;border-radius: 10px;box-shadow: 0 0 20px rgba(235,235,235,.8);overflow: hidden;display: block;}
    .audit_list_img img{width: 100%;height: 100%;object-fit: cover;display: block;transition: all ease .5s;}
    .audit_list:hover .audit_list_img img{transform: scale(1.05);}
    .audit_list h2{width:100%;padding:35px 15px;font-size: 24px;line-height: 34px;display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 2;overflow: hidden;font-weight: normal;color:#333;}
    .audit_list p{width: 100%;}
    .audit_list p span{width: auto;font-size:21px;line-height: 33px;padding:0 10px;color:#000;display: block;border:1px solid #000;border-radius: 16px;margin-right: 16px;margin-bottom: 5px;}

    .wall_map_list_first{width: 395px;padding:18px;display: block;}
    .wall_map_list a{width: 100%;display: block;}
    .wall_map_img,.wall_map_img img{width: 360px;height: 360px;object-fit: cover;display: block;transition: all ease .5s;overflow: hidden;border-radius: 10px;}
    .wall_map_list:hover .wall_map_img img{transform: scale(1.05);}
    .wall_map_list h2{width:100%;padding:35px 15px;font-size: 24px;line-height: 34px;height: 138px;display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 2;overflow: hidden;font-weight: normal;color:#333;}
    .wall_map_list p{width: 100%;padding-bottom: 37px;}
    .wall_map_list p span{width: auto;font-size:20px;line-height: 32px;padding:0 17px;color:#000;display: block;border:1px solid #000;border-radius: 10px;margin-right: 24px;margin-bottom: 5px;}

    .wall_map_list_second,.wall_map_list_second_img{width: 395px;height: 605px;display: block;overflow: hidden;}
    .wall_map_list_third_img,.wall_map_list_third{width: 410px;height: 605px;display: block;overflow: hidden;}
    .wall_map_list_second_img img,.wall_map_list_third_img img{width: 100%;height: 100%;object-fit: cover;display: block;transition: all ease .5s;}
    .wall_map_list:hover .wall_map_list_second_img img, .wall_map_list:hover .wall_map_list_third_img img{transform: scale(1.05);}



    .img_list{width:282px;margin-right: 24px;display: block;background: #fff;padding:18.5px;}
    .img_list:nth-child(4){margin-right: 0;}
    .img_list a{width: 100%;display: block;}
    .img_list_img,.img_list_img img {width: 245px;height: 245px;object-fit: cover;display: block;transition: all ease .5s;overflow: hidden;border-radius: 5px;}
    .img_list:hover .img_list_img img{transform: scale(1.05);}
    .img_list h2{width:100%;padding:35px 15px;font-size: 24px;line-height: 34px;height: 138px;display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 2;overflow: hidden;font-weight: normal;color:#333;}
    .img_list p{width: 100%;padding-bottom: 11.5px;}
    .img_list p span{width: auto;font-size:20px;line-height: 33px;padding:0 10px;color:#000;display: block;border:1px solid #000;border-radius: 16px;margin-right: 16px;margin-bottom: 5px;}


    .padding_left_half{padding-left:19.5px;}
    .pa_top_15{padding-top:15px;}
    .mr_top_70{margin-top:70px;}
    .mr_bottom_20{margin-bottom: 20px;}
    .no_bg{background: none !important;}

    .wall_map_list_second h2,.wall_map_list_second p{display: none;}


    @media screen and (max-width: 1920px) {

        .web_hide{display: none !important;}
        .web_show{display: block;}
        .audit{padding-top:1px;padding-bottom: 9.27vw;}

        .banner img{height: 62.9vw;min-height: auto;}
        .text_pic{width: 100%;padding:5.6vw 2% 0;}
        .text_pic ul li{width: 100%;margin-bottom: 3.2vw;}
        .text_box{width: calc(100% - 220px);}
        .mr_bottom_20{margin-bottom: 3.2vw;}


        .web_audit_swiper{margin:0 auto 0;width:96%;}
        .web_main{margin:3.2vw auto 0;width:96%;}
        .web_main .main.mr_top_70{margin-top:0;}

        .video{overflow: hidden;}
        .audit_list{width:50%;margin:3.2vw 0 3.2vw !important;padding:0 3.2vw;}
        .audit_list_img{height: 41.53vw;max-height: 490px;}
        .audit_list h2{margin:1.45vw 0 3.629vw;}
        .audit_list p span{border-radius: 5px;margin-right: 1.29vw;}


        .img_list{width: 48%;min-width: 48%;margin-right: 4%;position: relative;padding:2vw;}
        .overflow_x_auto{overflow-x: auto;}
        .overflow_x_auto::-webkit-scrollbar{display: none;}
        .img_list_img, .img_list_img img,
        .wall_map_list_second_img,.wall_map_img,.wall_map_list_second_img img,
        .wall_map_img img,.wall_map_list_second_img img,
        .wall_map_list_third_img img,.wall_map_list_third_img,
        .wall_map_list_third{width: 100%;height: 40vw;max-height: 490px;}

        /*.img_list p, .wall_map_list p{position: absolute;bottom:2%; left:18.5px;}*/
        .img_list p span, .wall_map_list p span{border-radius: 5px;margin-right: 1.29vw;}
        .wall_map_list p{padding:0;}
        .img_list p{padding-bottom: 0;}


        .wall_map_list_second h2,.wall_map_list_second p{display: block;}
        .wall_map_list p{bottom:4%;}
        .wall_map_list{width: 48%;min-width: 48%;margin-right: 4%;background: #fff;padding:2vw; position: relative;}
        .wall_map{background: #eef1fa;}
        .wall_map_list_second, .wall_map_list_second_img,.wall_map_list_third_img, .wall_map_list_third{height: auto;}

        .web_audit_swiper{position: relative;width: 100%;padding:0 2%;}
        .web_audit_swiper .main{position: relative;z-index:2;background: unset !important;}
        .web_audit_swiper_bg{position: absolute;width:100%;height: 100%;top:0;right:0;bottom:0;left:0;z-index:1;}
        .web_audit_swiper_bg img{width: 100%;height: 100%;object-fit: cover;display: block;}
        .web_audit_swiper .text_pic_top_title{background: unset;color:#fff;padding-left:0;}
        .web_audit_swiper .text_pic_top_title p,.web_audit_swiper .text_pic_top_title a,.web_audit_swiper .audit_list h2,.web_audit_swiper .audit_list p,.web_audit_swiper .audit_list p span{color:#fff;}


        .web_audit_swiper .audit_box{padding:0 4%;}
        .web_audit_swiper .audit_list p span:nth-child(3n),.web_audit_swiper .audit_list p span:first-child{color:#cf19da;border-color: #cf19da;background: rgba(255,255,255,.2);}
        .web_audit_swiper .audit_list p span:nth-child(3n + 1){color:#ff6000;border-color: #ff6000;background: rgba(255,255,255,.2);}
        .web_audit_swiper .audit_list p span:nth-child(3n + 2){color:#fff333;border-color: #fff333;background: rgba(255,255,255,.2);}
        .web_audit_swiper .audit_list p.audit_flag_list span:nth-child(3n),.web_audit_swiper .audit_list p.audit_flag_list span:first-child{color:#ffabf8;border-color: #ffabf8;background: rgba(255,255,255,.2);}
        .web_audit_swiper .audit_list p.audit_flag_list span:nth-child(3n + 1){color:#00ffea;border-color: #00ffea;background: rgba(255,255,255,.2);}
        .web_audit_swiper .audit_list p.audit_flag_list span:nth-child(3n + 2){color:#fff333;border-color: #fff333;background: rgba(255,255,255,.2);}

        .web_audit_swiper .audit_list_img{padding:0;box-shadow: unset;height: 37vw;}
        .web_audit_swiper .web_audit_page_btn{width:4.838vw;height:4.838vw;background: rgba(255,255,255,.6);text-align: center;line-height: 60px;border-radius: 50%;display: flex;justify-content: center;align-items: center;z-index: 9;}
        .web_audit_swiper .web_audit_page_btn img{width: 50%;object-fit: contain;display: block;}
        .web_audit_swiper .web_audit_page_btn.video_prev,.audit_prev{left:0;}
        .web_audit_swiper .web_audit_page_btn.video_next,.audit_next{right:0;}
    }
    @media screen and (max-width: 1240px) {
        .img_list h2, .wall_map_list_second h2,  .wall_map_list h2,.audit_list h2,.video_list h2{    width: 100%;
            margin: 1.6vw 0;
            font-size: 2.58vw;
            line-height: 3vw;
            height: auto;
            padding: 0;}
        .audit_list p span,.wall_map_list p span,.img_list p span{width: auto;font-size:14px;line-height: 21px;}
    }
    @media screen and (max-width: 960px) {
        .banner_main{width:100%;padding:0 2%;}
        .banner_main h2{font-size:7.5vw;line-height: 7.5vw;}
        .banner_main h3{letter-spacing: 0.729vw;margin:1.0416vw 0 4.166vw;}
        .banner_main h4{font-size:2.9166vw;line-height: 2.9166vw;letter-spacing: 0;}
        .banner_main form,.banner_main ul{height: 6.25vw;line-height: 6.25vw;}
        .banner_main form input {width: 67.1875vw;line-height: 6.25vw;font-size: 2.2916vw;padding: 0 2.0833vw;}
        .banner_main form button{width: 11.979vw;line-height: 6.25vw;font-size: 2.70833vw;}
        .banner_main ul li{font-size:1.875vw;padding:0 3.125vw;}
        .banner_main ul{display: none !important;}
    }
    @media screen and (max-width: 750px) {
        .img_list h2,.wall_map_list h2,.audit_list h2,.video_list h2{font-size: 18px;line-height: 24px;}
        .wall_map_list p{flex-wrap: wrap;}
        .wall_map_list p span{font-size:14px;line-height: 21px;margin-bottom: 3px;}
        .web_audit_swiper .web_audit_page_btn{width: 5vw;height: 5vw;}
        .wall_map_list,.img_list{padding-bottom: 4vw;}
        .text_box h2{font-size:20px;line-height: 26px;}
        .text_box p{font-size:14px;line-height: 18px;margin-bottom: 0;}
    }
    @media screen and (max-width: 640px) {
        .text_pic_top_title p{font-size:5.25vw;}
        .text_pic_top_title a{font-size:3vw;}
        .text_pic_top_title{margin-bottom: 3.2vw;height: 10.9375vw;line-height: 10.9375vw;padding-left:6.25vw;}
        .text_pic_top_title::before{height: 10.9375vw;}
        .text_pic ul li{padding:3.125vw;height: auto;}
        .text_pic ul li img, .pic_box{width: 31.25vw;height: 31.25vw;}
        .text_box{width: calc(100% - 31.25vw - 3.125vw);}
        .text_box h2,.text_box p{height: auto;}
        .text_box{position: relative;}
        .text_box p{margin-bottom: 30px;}
        .text_box span{position: absolute;bottom:0;left:0;width: 100%;}
        .text_box span label{white-space: nowrap;margin-right: 0;}

        .img_list p span,.wall_map_list p span,.audit_list p span{font-size:10px;line-height: 18px;padding:0 5px;}
        .img_list h2,.wall_map_list h2,.audit_list h2{font-size:16px;line-height: 18px;height: 36px;}
    }
    @media screen and (max-width: 500px) {
        .text_box h2{font-size:16px;line-height: 24px;}
        .text_box p{font-size:12px;line-height: 16px;margin-bottom: 0;}
    }
    @media screen and (max-width: 440px) {
        /*.audit_list{width:100%;}
        .audit_list_img{height: 90vw;}
        .web_audit_swiper .audit_list_img{height:80vw;}*/
    }
</style>



// WEBPACK FOOTER //
// src/pages/home/index.vue